/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */

function flag(healthEntryState) {
  return {
    get: () => healthEntryState.flagged,
    set: (value) => { healthEntryState.flagged = value; },
    toggle: () => { healthEntryState.flagged = !healthEntryState.flagged; },
    isFlagged: () => healthEntryState.flagged,
  };
}

export default flag;
